import { SurveyListResponsePayload } from './types';

const signupWizardSurveyType = 'signup_wizard';
const companyFormQuestionType = 'company_form';
const selfEmployedAnswerOption = 'self_employed';

export const isLeadSelfEmployed = (surveys: SurveyListResponsePayload) => {
  const signupWizardSurvey = surveys?.find((survey) => survey.type === signupWizardSurveyType);

  const companyFormQuestion = signupWizardSurvey?.answers.find(
    (answeredQuestion) => answeredQuestion.questionType === companyFormQuestionType,
  );

  const selfEmployedAnswer = companyFormQuestion?.answers.find(
    (answerOption) => answerOption.option === selfEmployedAnswerOption,
  );

  return selfEmployedAnswer?.state === 'checked';
};
